import React, { useState } from "react";
import { useSelector } from "react-redux";
import { CPagination } from "@coreui/react";
import numbro from "numbro";
import { BreakdownMetricFilter } from "./BreakdownByMetricFilter";

export const BreakdownByMetric = () => {
  const metrics = useSelector((state) => state.leadStatus.metrics);

  const [filterValue, setFilterValue] = useState("");
  const noMetrics = metrics.every((metric) => metric.data.length == 0);

  const filteredMetrics = metrics.map((metric) => {
    const data = metric.data.filter(({ name, info }) => {
      return (
        name.toLowerCase().includes(filterValue.toLowerCase()) ||
        info.toLowerCase().includes(filterValue.toLowerCase())
      );
    });

    return {
      ...metric,
      data
    };
  });

  return (
    <>
      <div className="lead-status-cards" style={noMetrics ? { marginBottom: "200px" } : {}}>
        {filteredMetrics.map(
          ({ title, count, rawDataLink, data, filterKey, filterName }, index) => {
            const [page, setPage] = useState(1);
            const totalPages = Math.ceil(data.length / 10) || 1;
            let paginatedData = data.slice((page - 1) * 10, page * 10);

            return (
              <div className="card" key={index}>
                {filterKey ? (
                  <div className="card__filter">
                    <BreakdownMetricFilter slice={filterKey} name={filterName} />
                  </div>
                ) : (
                  <div className="lead-status-search">
                    <div className="form-inline pl-0 c-datatable-filter search">
                      {/* move search input to components and adjust as in design system */}
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search..."
                        aria-label="table filter input"
                        value={filterValue}
                        onChange={(e) => setFilterValue(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                <div className="card__header">
                  <div className="card__title">{title}</div>
                  <div className="card__count">
                    <a href={rawDataLink} target="_blank" rel="noopener noreferrer">
                      {numbro(count).format({ thousandSeparated: true })}
                    </a>
                  </div>
                </div>
                {paginatedData.map(({ name, info, link }) => {
                  return (
                    <div className="card__el" key={link}>
                      <a
                        className="card__link"
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {name}
                      </a>
                      <span className="card__info"> - {info}</span>
                    </div>
                  );
                })}
                <div className="card__pagination">
                  <CPagination
                    style={{ display: totalPages > 1 ? "inline" : "none" }}
                    pages={totalPages}
                    limit={3}
                    activePage={page}
                    onActivePageChange={(page) => {
                      setPage(page);
                    }}
                  />
                </div>
              </div>
            );
          }
        )}
      </div>
    </>
  );
};
